export const hasNewPodInput = ({
  pdfFile,
  photos = [],
  signature,
  damageAcknowledged = 'No',
  acknowledgedBy,
  itemStatuses = [],
} = {}) => (
  Boolean(pdfFile) ||
  photos.length > 0 ||
  Boolean(signature) ||
  damageAcknowledged === 'Yes' ||
  Boolean(String(acknowledgedBy || '').trim()) ||
  itemStatuses.some((status) => Boolean(status) && status !== 'COMPLETE')
)

export const shouldUseSavedPod = ({ hasSavedPod, ...podInput } = {}) => (
  Boolean(hasSavedPod) && !hasNewPodInput(podInput)
)
